import type { JSX } from 'react';
import { Topbar } from './AdminLayout.js';
import { Icon } from '../components/Icon.js';
import { MOCK } from '../mock.js';
import { relativeTime } from '../utils/format.js';

export function AuditLog(): JSX.Element {
  return (
    <>
      <Topbar title="Аудит-лог" mock />
      <div style={{ padding: '24px 28px', flex: 1, overflowY: 'auto' }}>
        <div className="card">
          <div className="card-header">
            <div className="card-title">Последние действия</div>
            <div className="row" style={{ gap: 8 }}>
              <button type="button" className="btn btn-sm">
                <Icon name="filter" size={13} />
                Фильтры
              </button>
              <button type="button" className="btn btn-sm">
                <Icon name="download" size={13} />
                Экспорт
              </button>
            </div>
          </div>
          <table className="tbl">
            <thead>
              <tr>
                <th style={{ width: 140 }}>Время</th>
                <th>Пользователь</th>
                <th>Действие</th>
                <th>Сущность</th>
                <th>ID</th>
              </tr>
            </thead>
            <tbody>
              {MOCK.audit.map((a) => (
                <tr key={a.id} className="no-hover">
                  <td>
                    <span className="subtle" style={{ fontSize: 12.5 }}>
                      {relativeTime(a.createdAt)}
                    </span>
                  </td>
                  <td>
                    <span style={{ fontSize: 13 }}>{a.userEmail}</span>
                  </td>
                  <td>
                    <span className="mono" style={{ fontSize: 12.5 }}>
                      {a.action}
                    </span>
                  </td>
                  <td>
                    <span
                      className="chip chip-neutral no-dot"
                      style={{ fontSize: 10.5 }}
                    >
                      {a.entity}
                    </span>
                  </td>
                  <td>
                    <span className="mono subtle" style={{ fontSize: 12 }}>
                      {a.entityId ?? '—'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
